import type { ParseKeys } from 'i18next';
import { createBrowserRouter, RouterProvider } from 'react-router';

import RootLayout from '@/app/layouts/RootLayout';
import { GlobalErrorBoundary } from '@/app/routes/components/GlobalErrorBoundary';
import { RootRedirect } from '@/app/routes/components/RootRedirect';
import { UnknownRoute } from '@/app/routes/components/UnknownRoute';
import LoginPage from '@/auth/components/LoginPage';
import { GuestOnlyRoute } from '@/auth/GuestOnlyRoute';
import { ProtectedRoute } from '@/auth/ProtectedRoute';
import BillingListPage from '@/billing/component/BillingListPage';
import PolicyDetailPage from '@/policy/component/PolicyDetailPage';
import PolicyListPage from '@/policy/component/PolicyList/PolicyListPage';
import RenewalPriorizerPage from '@/renewal/component/RenewalPrioritizerPage';

export interface NavigationHandle {
  navLabel: ParseKeys;
  navValue: string;
}

const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <GlobalErrorBoundary />,
    children: [
      {
        path: '',
        element: <RootRedirect />,
      },
      {
        path: 'login',
        element: (
          <GuestOnlyRoute>
            <LoginPage />
          </GuestOnlyRoute>
        ),
      },
      {
        path: 'policy',
        handle: { navLabel: 'policyList', navValue: 'policy' },
        element: (
          <ProtectedRoute redirectTo="/login">
            <RootLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: '',
            element: <PolicyListPage />,
          },
          {
            path: ':uuid',
            element: <PolicyDetailPage />,
          },
        ],
      },
      {
        path: 'billing',
        handle: { navLabel: 'billingList', navValue: 'billing' },
        element: (
          <ProtectedRoute redirectTo="/login">
            <RootLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: '',
            element: <BillingListPage />,
          },
        ],
      },
      {
        path: 'renewal-prioritizer',
        handle: {
          navLabel: 'renewalPrioritizer',
          navValue: 'renewal-prioritizer',
        },
        element: (
          <ProtectedRoute redirectTo="/login">
            <RootLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: '',
            element: <RenewalPriorizerPage />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <UnknownRoute />,
  },
]);

export const Router = () => <RouterProvider router={router} />;
